<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
		<FormItem prop="trackName" :label="this.$t('Station')" :label-width="60">
			<Select v-model="formInline.StationId" filterable :placeholder="this.$t('Station')" style="width: 120px;">
				<Option :value='0'>{{ this.$t('Common.All') }}</Option>
				<Option :key="itemIndex" v-for="(item,itemIndex) in StationList" :value="item.StationId">
					{{item.StationName}}
				</Option>
			</Select>
		</FormItem>
		<FormItem prop="trackName">
			<Input style="width: 180px;" type="text" v-model="formInline.EquipmentModel" :placeholder="this.$t('EquipmentModel')">
			<span slot="prepend">{{ this.$t('EquipmentModel') }}</span>
			</Input>
		</FormItem>
		<FormItem prop="trackName">
			<Input style="width: 180px;" type="text" v-model="formInline.ConnectorNo" :placeholder="this.$t('ConnectorNo')">
			<span slot="prepend">{{ this.$t('ConnectorNo') }}</span>
			</Input>
		</FormItem>
		
		<FormItem :label="this.$t('Time')" :label-width='70'>
			<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
				v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('handleSubmit')" v-if="hasWidgets('search')">{{ $t('Common.Search') }}</Button>
		</FormItem>
	</Form>
</template>

<script>
	import dateFormat from '../../../../../public/js/comm.js'
	import {
		mapState,
	} from 'vuex'
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					StationId: 0,
					EquipmentModel: '',
					ConnectorNo: '',
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 6), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 6), new Date()],
				},
			};
		},
		computed: {
			
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("date change", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			}
		},
	}
</script>

<style>
</style>
